import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { BaseComponent } from '@src/app/commons/BaseComponent';
import { Constants } from '@src/app/commons/Constants';
import { PluginController } from '@src/app/commons/plugins/plugin-controller';
import { FdmPlugin } from '@src/app/commons/plugins/plugins';
import { SceneControllerService } from '@src/app/service/controllers/scene-controller.service';
import { PluginManagerService } from '@src/app/service/plugin-manager.service';
import { XsApplicationEventsService } from '../../events/application-events.service';
import { UiManagerService } from '../ui-manager.service';

@Component({
  selector: 'xs-camera-controller',
  templateUrl: './camera-controller.component.html'
})
export class XsCameraControllerComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  debug = false;

  // show the component?
  show:boolean = false;

  // what plugin is in action
  plugin:FdmPlugin = null;
  
  // What popover controller is in control?
  @Input()
  controller:any;

  // What's the context? Who's calling the shots?
  @Input()
  context:any = this;
  

  // id for the popover panel itself
  id:string = null;

  // plugin controller
  @Input()
  pluginController:PluginController;


  items:any[] = [];

  constructor ( 

    // the three BaseComponent services
    public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, 

    // others we need
    public uiManager: UiManagerService,
    public sceneController: SceneControllerService,
    public applicationEvents:XsApplicationEventsService, 
    public pluginManager: PluginManagerService

  ) { super(router, snackBar, dialog); if ( this.debug ) { console.log('CameraControllerCOMPONENT %c [dunnoyet] %c CONSTRUCT', Constants._pink, Constants._pink); } }

  // look for changes to the @input variables
  ngOnChanges() {

    if ( this.debug ) { console.log('CameraCtrl %c [dunnoyet] %c ngChanges() ', Constants._pink, Constants._pink, this.pluginController, this.controller ); }

    if ( this.pluginController ) {
      this.pluginController.injectComponent(this);
    }

    // this controller is the popover controller (works as a bridge between the popower 
    // component and where it works from, for example layers.comp or map.comp, etc.)
    if ( this.controller ) {
      
      this.controller.injectComponent(this);

      // different contexts bring different plugin controllers
      if ( this.controller.pluginController ) {
        this.pluginController = this.controller.pluginController;
      }
    }
  }

  init() {

    // just use the component UUID as the popover id
    this.id = this.__ID.instance;

    if ( this.debug ) { console.log('CameraCtrl %c '+this.__ID.instance+' %c COMPONENT INIT', Constants._pink, Constants._pink ); }

  }

  open() {
    this.show = true;
  }

  close() {
    this.show = false;
  }

  add(i){
    this.capture(i);
    // console.log('#add', i );
  }

  capture(i){
    let category = i['category'];
    let item = i.data && i.data.obj ? i.data.obj : { error:'no such item', category, i };
    item['cameraPosition'] = this.sceneController.getCamera();
    i.data.global.camera = item['cameraPosition'];
    // console.log('#capture',category, i, item, item['cameraPosition'] );
    setTimeout( () => { i.captured = true; }, 400 );
    setTimeout( () => { i.captured = false; }, 3000 );
    item.saveObservable().subscribe();
  }

  flyTo(i){
    let category = i['category'];
    let item = i.data && i.data.obj ? i.data.obj : { error:'no such item', category, i };
    // console.log('#flyto', category, i, item, item['cameraPosition'] );
    if ( item['cameraPosition'] ) {
      this.sceneController.flyToCamera( item['cameraPosition'] );
    }
    
  }

  delete(i){
    let category = i['category'];
    let item = i.data && i.data.obj ? i.data.obj : { error:'no such item', category, i };
    item['cameraPosition'] = null;
    delete item['cameraPosition'];
    i.data.global.camera = null;
    // this.sceneController.checkForCameraBookmarks(category,item);
    // console.log('#delete',category, i, item, item['cameraPosition'] );
    item.saveObservable().subscribe();
  }


}
